import { render, staticRenderFns } from "./GoldenRecord.vue?vue&type=template&id=05c85617&scoped=true&"
import script from "./GoldenRecord.vue?vue&type=script&lang=js&"
export * from "./GoldenRecord.vue?vue&type=script&lang=js&"
import style0 from "./GoldenRecord.vue?vue&type=style&index=0&id=05c85617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c85617",
  null
  
)

export default component.exports